import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfigWeb = {
  apiKey: process.env.REACT_APP_FIREBASE_WEB_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_WEB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_WEB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_WEB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_WEB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_WEB_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_WEB_MEASUREMENT_ID,
};

const firebaseConfigMobile = {
  apiKey: process.env.REACT_APP_FIREBASE_MOBILE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_MOBILE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_MOBILE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_MOBILE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_MOBILE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MOBILE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_MOBILE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MOBILE_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfigWeb);
export const appMobile = initializeApp(firebaseConfigMobile, "mobileApp");

export const auth = getAuth(app);
export const authMobile = getAuth(appMobile);

export const db = getFirestore(app);
export const dbMobile = getFirestore(appMobile);

export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export const schoolCollectionRef = collection(db, "schools");
export const parentsCollectionRef = collection(db, "parents");
export const participantsCollectionRef = collection(db, "participants");
export const paymentCollectionRef = collection(db, "payments");
export const questionsCollectionRef = collection(db, "questions");
